'use client';

import Script from 'next/script';
import { useEffect, useMemo } from 'react';
import { jwtDecode } from 'jwt-decode';
import { appConfig } from '@/config/app';
import { authKeys } from '@/config/keys';
import { salesforceConfig } from '@/config/salesForce';
import { getCookie } from '@/utils/cookies';
export const SFChatScript = () => {
  const userRaw = getCookie(authKeys.authToken);
  const user = useMemo(() => userRaw ? jwtDecode<TempUser>(userRaw) : {
    document: null,
    email: null,
    name: null
  }, [userRaw]);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('onEmbeddedMessagingReady', () => {
        const {
          firstName,
          lastName
        } = separateFirstAndLastName(user.name);
        window.embeddedservice_bootstrap?.prechatAPI.setVisiblePrechatFields({
          _firstName: {
            value: firstName,
            isEditableByEndUser: false
          },
          _lastName: {
            value: lastName,
            isEditableByEndUser: false
          },
          _email: {
            value: user.email ?? '',
            isEditableByEndUser: false
          }
        });
        window.embeddedservice_bootstrap?.prechatAPI.setHiddenPrechatFields({
          cpfCnpj: user.document ?? ''
        });
      });
    }
  }, [user]);
  if (!appConfig.isProduction) {
    return <></>;
  }
  return <Script src={`${salesforceConfig.instanceUrl}/${salesforceConfig.salesforceChat.chatName}/assets/js/bootstrap.min.js`} onLoad={initESW} data-sentry-element="Script" data-sentry-component="SFChatScript" data-sentry-source-file="SFChatScript.tsx" />;
};
const initESW = () => {
  const embeddedservice_bootstrap = window.embeddedservice_bootstrap;
  if (!embeddedservice_bootstrap) {
    return;
  }
  embeddedservice_bootstrap.settings.language = 'pt_BR';
  embeddedservice_bootstrap.init(salesforceConfig.salesforceChat.queueId, salesforceConfig.salesforceChat.queueName, `${salesforceConfig.instanceUrl}/${salesforceConfig.salesforceChat.chatName}`, {
    scrt2URL: salesforceConfig.salesforceChat.scrt2URL
  });
};
const separateFirstAndLastName = (name: string | null = '') => {
  if (!name) return {
    firstName: 'Usuário',
    lastName: 'sem nome'
  };
  const [firstName, ...lastName] = name.split(' ');
  const joinedLastName = lastName.length > 0 ? lastName.join(' ') : '';
  return {
    firstName,
    lastName: joinedLastName
  };
};
type TempUser = {
  document: string;
  email: string;
  name?: string;
};